import { Component, ViewChild } from '@angular/core';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { TranslateService } from '@ngx-translate/core';
import { Nav, Platform, ModalController, Navbar, IonicApp, Events, ToastController } from 'ionic-angular';

import { HelperService } from '../providers/helper/helper';
import { AndroidFullScreen } from '@ionic-native/android-full-screen/ngx';
import { Deeplinks } from '@ionic-native/deeplinks/ngx';
import { Storage } from '@ionic/storage';


import { WelcomePage } from '../pages/welcome/welcome';

@Component({
  template: `<ion-nav [root]="rootPage"></ion-nav>`
})
export class MyApp {

  rootPage = 'SplashPage';

  @ViewChild(Nav) nav: Nav;
  @ViewChild(Navbar) navBar: Navbar;

  backButtonCount: number = 0;

  constructor(private translate: TranslateService, private platform: Platform, private statusBar: StatusBar, private helperService: HelperService,
    private modalCntrl: ModalController, public storage: Storage, androidFullScreen: AndroidFullScreen, public toastCtrl: ToastController,
    private deeplinks: Deeplinks, ionicApp: IonicApp, private events: Events) {
    platform.ready().then(() => {
      if (this.platform.is("cordova")) {
        // Okay, so the platform is ready and our plugins are available.
        // Here you can do any higher level native things you might need. 
        this.statusBar.styleDefault();
        // this.modalCntrl.create('SplashPage').present();
        androidFullScreen.isImmersiveModeSupported()
          .then(() => androidFullScreen.immersiveMode())
          .catch((err: any) => {
            window.onerror("app component androidFullScreen : " + JSON.stringify(err), window.location.href, 38, 0);
          });
      }
    });
    this.initTranslate();

    platform.pause.subscribe(() => {
      storage.get('profile_data').then(data => {
        let _profileData = JSON.parse(data);

        this.helperService.saveData(_profileData).subscribe((response: any) => {
          if (response[0].insertId)
            _profileData.profiles_id = response[0].insertId;
          storage.set('profile_data', JSON.stringify(_profileData));
        });

      }).catch((err) => {
        window.onerror("app component profile_data no exist : " + JSON.stringify(err), window.location.href, 55, 0);
      });
    });

    platform.registerBackButtonAction(() => {
      let activePortal = ionicApp._loadingPortal.getActive() ||
        ionicApp._modalPortal.getActive() ||
        ionicApp._toastPortal.getActive() ||
        ionicApp._overlayPortal.getActive();

      if (activePortal) {
        return activePortal.dismiss();
      }
      // else if (this.nav.getActive().name == 'l') {
      //   this.nav.setRoot('OverviewPage');
      // }
      else if (this.nav.getActive().name == 'OverviewPage' || !this.nav.canGoBack()) {
        if (this.backButtonCount == 0) {
          this.backButtonCount++;
          toastCtrl.create({
            message: 'Press back button again to exit',
            duration: 3000
          }).present();
        }
        else if (this.backButtonCount == 1)
          platform.exitApp();
      }
      else {
        this.nav.pop({ animate: true, direction: 'back', animation: 'ios-transition' });
      }
    });

    platform.resume.subscribe(() => {
      storage.get('visitor_id').then(visitorId => {
        this.helperService.syncData(visitorId);
      }).catch((err) => {
        window.onerror("platform resume : " + JSON.stringify(err), window.location.href, 91, 0);
      });
    });
  }

  ngAfterViewInit() {
    this.platform.ready().then(() => {
      if (this.platform.is("cordova")) {
        this.deeplinks.routeWithNavController(this.nav, {
          '/session/:sessionId': WelcomePage
        }).subscribe((match) => {
          // match.$route - the route we matched, which is the matched entry from the arguments to route()
          // match.$args - the args passed in the link
          // match.$link - the full link data
        }, (nomatch) => {
          // nomatch.$link - the full link data
        });
      }
    });
    this.events.subscribe('scan:exit', (navCtrl) => {
      let modal = this.modalCntrl.create('ExitScanPage', {}, { enableBackdropDismiss: true, cssClass: 'exit-scan-modal' });
      modal.present();
      modal.onDidDismiss(data => {
        if (data) {
          this.helperService.navigateToOverview(navCtrl);
        }
      })
    });
  }
  initTranslate() {
    // For pre fetching the language files
    this.translate.instant("ABOVE_MEDIAN");
    // Set the default language for translation strings, and the current language.
    this.helperService.checkAndSaveLangugae();
  }


  showComments() {
    let commentsModal = this.modalCntrl.create('CommentsPage');
    commentsModal.present();
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts